<query-table-selector></query-table-selector>

<!--TODO: port RB2 query filter panel-->
